module.exports = __webpack_public_path__ + "img/ico_talk_bot.aa571077.png";